import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../components/Common/imageWithBasePath";
import { loginService } from "../../../services/authService";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

type PasswordField = "password";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
// Our home page is the login page, so we add this line to redirect the user to the dashboard if they are already logged in.
  const user = useSelector((state: RootState) => state.authSlice.user);
  const accessToken = useSelector((state: RootState) => state.authSlice.accessToken);

  useEffect(() => {
    if (user && accessToken) {
      navigate(all_routes.dashboard);
    }
  }, [user, accessToken]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  useEffect(() => {
    localStorage.setItem("menuOpened", "Dashboard");
  }, []);

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await loginService(email, password);
      console.log(response);
      if (response?.user?.role === "admin") {
        navigate("/super-admin/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="container">
      <div
        className="row justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="col-md-5">
          <form onSubmit={handleLogin} className="px-3 py-4">
            {/* Logo */}
            <div className="text-center mb-3">
              <ImageWithBasePath
                src="assets/img/authentication/logo-1.webp"
                className="mw-100"
                alt="Logo"
                width={400}
              />
            </div>

            {/* Login Card */}
            <div className="card">
              <div className="card-body p-4">
                <div className="mb-4 text-center">
                  <h2 className="mb-2">{t("welcome")}</h2>
                  <p className="mb-0">{t("enter_details_to_sign_in")}</p>
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("email_address")}</label>
                  <div className="input-icon mb-3 position-relative">
                    <span className="input-icon-addon"></span>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      required
                    />
                  </div>

                  <label className="form-label">{t("password")}</label>
                  <div className="pass-group">
                    <input
                      type={
                        passwordVisibility.password ? "text" : "password"
                      }
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="pass-input form-control"
                      required
                    />
                    <span
                      className={`ti toggle-passwords ${
                        passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => togglePasswordVisibility("password")}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <button type="submit" className="btn btn-primary w-100">
                    {t("sign_in")}
                  </button>
                </div>
                <div className="mb-3">
                  <Link to={all_routes.forgotPassword}>
                    {t("forgot_password")}
                  </Link>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center mt-3">
              <p className="mb-0">
                {t("copyright")} © {new Date().getFullYear()} - Schoolation
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
